import axios from 'axios';
import { getAuthHeader, getBaseUrl } from '../../../../utils';
import { ComponentModel, ComponentSubType, ComponentType } from './models/components.models';

const axiosInst = axios.create({});

/**
 * Get list of components
 */
export const getComponents = async () => {
  const url = getBaseUrl() + '/components';
  const res = await axiosInst.get(url, { headers: getAuthHeader() });
  return res.data;
};

/**
 * Get component data by name
 * @param name
 */
export const getComponentByName = async (name: string) => {
  const url = getBaseUrl() + '/components/' + name;
  const res = await axiosInst.get(url, { headers: getAuthHeader() });

  return {
    ...res.data,
    // @ts-ignore
    Labels: res.data.Labels ? res.data.Labels.map(label => ({ text: label.Name, id: label.Name })) : []
  };
};

/**
 * Delete component by name
 * @param name
 */
export const deleteComponentByName = async (name: string) => {
  const url = getBaseUrl() + '/components/' + name;
  await axiosInst.delete(url, { headers: getAuthHeader() });
  return { success: { Name: name } };
};

/**
 * Create components
 * @param data
 * @param type
 * @param subType
 */
export const createComponent = async (data: ComponentModel, type: ComponentType, subType: ComponentSubType) => {
  const componentsUrl = getBaseUrl() + '/components';
  const labelUrl = componentsUrl + '/:name/tags';

  const componentData: ComponentModel = {
    ...data,
    type: type,
    subType: subType
  };

  // @ts-ignore
  const labels = data.labels.map(label => label.text);

  // @ts-ignore
  delete componentData.labels;

  await axios.post(componentsUrl, componentData, { headers: getAuthHeader() });
  await axios.post(labelUrl.replace(':name', componentData.name), labels, { headers: getAuthHeader() });

  return { success: { Name: componentData.name } };
};

/**
 * Edit component
 * @param data
 */
export const editComponent = async (data: ComponentModel, type: ComponentType, subType: ComponentSubType) => {
  const componentsUrl = getBaseUrl() + '/components';
  const labelUrl = componentsUrl + '/:name/tags';

  const componentData: ComponentModel = {
    ...data,
    type: type,
    subType: subType
  };

  // @ts-ignore
  const labels = data.labels?.map(label => label.text);

  // @ts-ignore
  delete componentData.labels;

  await axios.put(componentsUrl, componentData, { headers: getAuthHeader() });
  if(labels) {
    await axios.post(labelUrl.replace(':name', componentData.name), labels, { headers: getAuthHeader() });
  }

  return { success: { Name: componentData.name } };
};

/**
 * Export
 * @param name
 */
export const exportComponent = async (name: string) => {
  const exportUrl = getBaseUrl() + `/components/${name}/xml`;
  const res = await axios.get(exportUrl, { headers: getAuthHeader() });
  return res.data;
}

/**
 * Import
 */
export const importComponent = async (fileForm: any) => {
  const importUrl = getBaseUrl() + `/components/import/xml`;
  const res = await axios.post(importUrl, fileForm, { headers: getAuthHeader() });
  return { success: res.data };
}
/**
 * Set Active status for specified signal
 * @param name
 * @param active
 */
export const setSignalActiveStatus = async ({ name, active }: { name: string; active: boolean }) => {
    const action = active ? 'activate' : 'deactivate';
    const url = getBaseUrl() + `/components/${name}/${action}`;
    const res = await axios.post(url, undefined, { headers: getAuthHeader() });
    return res.data;
};